<template>
      <div class="seller-gq">
         <div class="opera-group">
            <a-button type="primary" @click="addItem()">添加供求</a-button>
         </div>   
         <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
                <span slot="supplyType" slot-scope="text">{{ $utils.getVal(projectDict[0].sys_supply_type,text) }}</span>
                <div slot="descContent" slot-scope="text" style="width:100px;height:30px;line-height:30px;white-space:nowrap; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">
                    <a-tooltip>
                     <template slot="title">
                        {{ text }}
                     </template>
                   {{ text }}
                  </a-tooltip>
                </div>   
                <div slot="picture" slot-scope="text">
                     <img :src="text" width="100" height="30">
                </div>   
                <template slot="action" slot-scope="text,record">
                  <div class="operate-btns">
                     <a-button type="primary" :disabled="record.status=='0'?true:false" @click="public(record)">{{ record.publishStatus=='0'?'发布':'取消发布' }}</a-button>
                  </div>
               </template>
           </a-table>
         </div>   
         <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
         <gqdialog ref="gqdialog" :projectDict="projectDict" @getDataList="getDataPage"></gqdialog>
      </div>  
</template>
<script>
import gqdialog from './gqdialog.vue'
const columns = [
   {
      title: '序号',
      dataIndex: 'projectCode',
      width: 50,
       customRender: (text,record,index) => `${index+1}`,
   },
   {
      title: '类别',
      dataIndex: 'projectCategoryName',
      width: 120,
      scopedSlots: { customRender: 'projectCategoryName' },
   },
   {
      title: '类型',
      dataIndex: 'supplyType',
      width: 120,
      scopedSlots: { customRender: 'supplyType' },
   },
   {
      title: '描述',
      dataIndex: 'descContent',
      width: 150,
      scopedSlots: { customRender: 'descContent' },
   },
   {
      title: '图片',
      id:'8',
      dataIndex: 'picture',
      width: 100,
      scopedSlots: { customRender: 'picture' },
   },
   {
      title: '操作',
      id:'8',
      dataIndex: 'operate',
      width: 200,
      scopedSlots: { customRender: 'action' },
   },
]   
export default {
   components:{
      gqdialog
   },
   data(){
       return{
           projectDict:[
               {
                   bg_project_category:[]
               }
           ],
           columns:columns,
           data:[],
           loading:false,
           params:{
              isSeller:'1',
              pageSize:10,
              pageNum:1
           },
           total:0,
       }
   },
   created(){
      this.$parent.activeIndex = 0;
      this.loading = true;
      this.$https.get('/portal/projectDict/list').then(res=>{
            if(res.code == 200){
               this.projectDict = res.rows;
               this.getDataList();
            }
       }).catch(error=>{
          this.$message.error('网络波动')
          this.loading = false;
       })
   },
   methods:{
      //添加项目
      addItem(){
           this.$refs.gqdialog.showDiolag();
      },
      getDataList(){
         this.loading = true;
         this.$https.get('/portal/entrust/list',{params:this.params}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                  res.rows.forEach(item=>{
                     let arr = item.pictureUrl.split(',');
                     item.picture = arr[0];
                  })
                  this.data = res.rows;
                  this.total = Number(res.total);
               }else{
                  this.$message(res.msg)
               }
         }).catch(error=>{
              this.loading = false;
         })
      },
      getList(page){
         this.params.pageNum = page;
         this.getDataList();
      },
      getDataPage(){
         this.params.pageNum = 1;
         this.getDataList();
      },
      public(row){
         let msg = row.publishStatus=='0'?'确定发布该条记录?':'确定取消发布该条记录？'
         let _this = this;
         this.$confirm({
            title:msg,
            content: '',
            onOk() {
               let obj = {
                  publishStatus:row.publishStatus=='0'?'1':'0',
                  supplyId:row.supplyId
               }
               _this.$https.get('/portal/entrust/updatePublish',{params:obj}).then(res=>{
                        if(res.code == 200){
                           _this.$message.success('操作成功');
                           _this.getDataPage();
                        }else{
                           _this.$message.error(res.msg)
                        }
               }).catch(error=>{
                        _this.$message.success('操作失败');
               })
            },
         onCancel() {},
         });
      }
   }
}
</script>
<style lang="less" scoped>
.opera-group{
   margin:0 0 20px 20px;
}
.operate-btns{
   .ant-btn{
      margin-right:8px;
   }
}
</style>